export default "__VITE_ASSET__6v0oURpk__"